import PropTypes from 'prop-types';
import Sprintf from 'sprintf-js';
import qs from 'qs';
import InfiniteScroll from 'react-infinite-scroller';
import SubHeader from './Parts/SubHeader';
import FilterFactory from './Filters/FilterFactory';
import axios from '../../services/axiosAuth';
import _ from 'lodash';
import { cloneDeep } from 'lodash';
import { MATCH_TYPE_RAW_DQL } from '../../constants/filterMatchTypes';
import downloadIcon from '../../icons/download-mobile.svg';
import summaryIcon from '../../icons/summary-mobile.svg';
import Record from './Mobile/Record';
import Loader from './Mobile/Loader';
import { FormattedMessage } from 'react-intl';
import SummaryModal from '../Modal/SummaryModal';
import CheckboxWrapper from './Parts/CheckboxWrapper';
import TabFilters from './Filters/TabFilters';
import CHECKBOX_STATES from '../../constants/checkBoxTypes';
import { setSelectedItems } from '../../reducers/selectedItemsActions';
import ActionBar from './ActionBar/ActionBar';
import { Component } from 'react';

const urlQueryPattern = '%s?%s';

class MobileDataTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      records: [],
      selectedRecords: [],
      data: [],
      loading: false,
      perPage: 10,
      filtersValue: props.defaultFilters || {},
      filtering: false,
      sortColumn: props.defaultSortField,
      sortDirection: props.sortDirection,
      summaryData: [],
      isSummaryOpen: false,
      isSummaryLoading: false,
      mainCheckboxSelected: false,
      afterAction: false,
    };

    this.handleFilterValueChange = this.handleFilterValueChange.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.setAfterAction = this.setAfterAction.bind(this);
  }

  async componentDidMount() {
    this.setState({ loading: true });
    if (this.props.location?.userProps?.triggerToConfirm) {
      await this.handleFilterValueChange({
        target: {
          label: 'toConfirm',
          name: 'toConfirm',
          selected: true,
          value: true,
        },
      });
      await this.handleFilter();
    } else {
      this.loadMore(1);
    }
  }
  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {
    const recordNotSelected = this.state.records.filter((record) => {
      return !record.selected;
    });
    const recordSelected = this.state.records.filter((record) => {
      return record.selected;
    });
    const recordToSelect = this.state.records.filter((record) => {
      return record.toConfirm;
    });
    if (this.state.selectedRecords && this.state.selectedRecords.length > 0) {
      if (!this.checkIfSelectedIsInView(this.state.records, this.state.selectedRecords).result) {
        if (this.state.mainCheckboxSelected !== CHECKBOX_STATES.Indeterminate) {
          this.setState({
            mainCheckboxSelected: CHECKBOX_STATES.Indeterminate,
          });
        }
      }
      if (recordToSelect.length > this.state.selectedRecords.length) {
        if (this.state.mainCheckboxSelected !== CHECKBOX_STATES.Indeterminate) {
          this.setState({
            mainCheckboxSelected: CHECKBOX_STATES.Indeterminate,
          });
        }
      }
    }
    if (this.props.selectable && !this.mainCheckboxDisabledDeterminer() && this.selectCriteria() && !this.state.afterAction) {
      if (
        this.state.data.count > recordNotSelected.length &&
        recordNotSelected.length !== 0 &&
        this.state.records.length !== recordNotSelected.length &&
        this.state.mainCheckboxSelected !== CHECKBOX_STATES.Indeterminate
      ) {
        this.setState({
          mainCheckboxSelected: CHECKBOX_STATES.Indeterminate,
        });
      }

      if (
        this.state.records.length === recordNotSelected.length &&
        this.state.mainCheckboxSelected !== false &&
        this.state.mainCheckboxSelected !== CHECKBOX_STATES.Indeterminate
      ) {
        this.setState({
          mainCheckboxSelected: false,
        });
      }
      if (recordSelected.length !== 0 && this.state.records.length === recordSelected.length && this.state.mainCheckboxSelected !== true) {
        this.setState({
          mainCheckboxSelected: true,
        });
      }
    }
  }

  selectCriteria = () => {
    return !!this.state.filtersValue.toConfirm;
  };
  checkIfSelectedIsInView = (records, recordsSelected) => {
    const recordsIds = records.map((record) => {
      return record.id;
    });
    const recordsSelectedIds = recordsSelected.map((record) => {
      return record.id;
    });
    const result = recordsIds.some((r) => recordsSelectedIds.indexOf(r) >= 0);
    return { result, recordsIds };
  };
  setAfterAction = () => {
    this.setState({
      afterAction: true,
    });
  };
  handleFilter = async (event, silent = false) => {
    this.props.dispatch(setSelectedItems([]));

    this.setState({
      selectedRecords: [],
      mainCheckboxSelected: false,
    });

    if (silent) {
      this.setState({ loading: true });
    } else {
      this.setState({ loading: true, filtering: true });
    }
    const { perPage, sortColumn, sortDirection, filtersValue } = this.state;

    try {
      const api = await axios.get(
        Sprintf.sprintf(urlQueryPattern, this.props.url, this.generateQueryString(1, perPage, sortColumn, sortDirection, filtersValue))
      );

      this.setState({
        loading: false,
        data: api.data,
        records: api.data.collection,
      });

      if (filtersValue.toConfirm) {
        if (!this.state.afterAction) {
          await this.mainCheckboxClickHandler(this.state.mainCheckboxSelected);
        } else {
          this.setState({
            mainCheckboxSelected: false,
          });
          this.mainCheckboxClickHandler(true);
        }
      } else {
        this.setState({
          mainCheckboxSelected: this.mainCheckboxCheckedOnLoad(this.state.records),
        });
      }
      this.setState({ filtering: false });
    } catch (error) {
      console.log(error);
    }
  };

  handleSummary = () => {
    const { filtersValue } = this.state;
    this.setState({
      isSummaryOpen: true,
      isSummaryLoading: true,
    });

    axios
      .get(Sprintf.sprintf(urlQueryPattern, this.props.url, qs.stringify(this.generateFiltersForQueryString(filtersValue))))
      .then((response) => {
        this.setState({ summaryData: response.data.collection });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.setState({ isSummaryLoading: false });
      });
  };

  generateQueryString = (page, perPage, sortColumn = null, sortDirection = null, filtersValue = null) => {
    let queryObject = {
      page: page,
      limit: perPage,
    };

    if (null !== sortColumn) {
      queryObject.sort = {};
      queryObject.sort[sortColumn] = sortDirection;
    }

    if (null !== filtersValue) {
      queryObject.filter = {};
      queryObject = this.generateFiltersForQueryString(filtersValue, queryObject);
    }

    return qs.stringify(queryObject);
  };

  generateFiltersForQueryString = (filtersValue, queryObject = null) => {
    if (queryObject === null) {
      queryObject = { filter: {} };
    }

    Object.keys(filtersValue).forEach((key) => {
      if (typeof filtersValue[key] === 'undefined' || filtersValue[key] === null || filtersValue[key] === '') {
        return;
      }

      const filter = this.props.filters.filter((filter) => filter.field === key)[0];

      if (typeof filter !== 'undefined') {
        queryObject.filter[key] = {
          value:
            filter.matchType === MATCH_TYPE_RAW_DQL
              ? JSON.stringify({
                  value: filter?.expression.value,
                  parameters: {
                    [key]: filter?.expression.wildcard ? '%' + filtersValue[key] + '%' : filtersValue[key],
                  },
                  // eslint-disable-next-line no-prototype-builtins
                  leftJoin: filter.expression.hasOwnProperty('leftJoin') ? filter.expression.leftJoin : null,
                })
              : filtersValue[key],
          matchType: filter.matchType,
        };
      } else {
        const dateRange = this.props.filters.filter((filter) => {
          return (
            // eslint-disable-next-line no-prototype-builtins
            filter.hasOwnProperty('availableFields') && filter.availableFields.includes(key)
          );
        })[0];

        if (
          dateRange.availableFields.filter((el) =>
            // eslint-disable-next-line no-prototype-builtins
            queryObject.filter.hasOwnProperty(el)
          ).length > 0
        ) {
          return;
        }

        const queryParameters = {};
        const queryFilters = dateRange.collection
          .filter((dateFilter) => filtersValue[dateFilter.field])
          .map((dateFilter) => {
            queryParameters[dateFilter.field] = filtersValue[dateFilter.field];
            return dateFilter?.expression.value;
          });

        queryObject.filter[key] = {
          value: JSON.stringify({
            value: queryFilters.join(' AND '),
            parameters: queryParameters,
          }),
          matchType: MATCH_TYPE_RAW_DQL,
        };
      }
    });

    return queryObject;
  };

  handleFilterValueChange = (event) => {
    const target = event.target;
    const filters = this.state.filtersValue;
    let value = [target.value];

    if (this.isMultiSelect(target.value)) {
      value = target.value.map((filter) => filter.value);
    } else if (this.isSelect(target.value) && typeof target.value !== 'undefined') {
      value = [target.value.value];
    }

    this.setState({
      filtersValue: {
        ...filters,
        [target.name]: value.join(),
      },
    });
  };

  isMultiSelect = (value) => Array.isArray(value);
  isSelect = (value) => typeof value === 'object' && value !== null;

  handleExport = () => {
    const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const { filtersValue } = this.state;

    axios
      .get(Sprintf.sprintf(urlQueryPattern, this.props.url, qs.stringify(this.generateFiltersForQueryString(filtersValue))), {
        responseType: 'blob',
        headers: {
          'Content-Type': contentType,
          Accept: contentType,
        },
      })
      .then((response) => {
        let filename = 'export.xlsx';
        // eslint-disable-next-line no-prototype-builtins
        if (response.headers.hasOwnProperty('Content-Disposition')) {
          decodeURI(response.headers.get('Content-Disposition').split('filename=')[1]);
        }

        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: contentType,
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  loadMore = (page) => {
    const { perPage, sortColumn, sortDirection, filtersValue } = this.state;

    axios
      .get(
        Sprintf.sprintf(urlQueryPattern, this.props.url, this.generateQueryString(page, perPage, sortColumn, sortDirection, filtersValue))
      )
      .then((response) => {
        const mergedRecords = [...this.state.records, ...response.data.collection];

        this.setState({
          loading: false,
          data: response.data,
          records: mergedRecords,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  selectRecordHandler = (record, bool, records) => {
    const selectedRecords = this.state.selectedRecords;
    let newSelectedRecords = !records ? [...selectedRecords] : [...records];
    let result = _.some(selectedRecords, function (rec) {
      return rec.id === record.id;
    });
    if (bool && !result && !records) {
      newSelectedRecords.push(record);
    }
    if (!bool && result && !records) {
      newSelectedRecords = newSelectedRecords.filter((rId) => {
        return rId.id !== record.id;
      });
    }
    if (records && bool) {
      newSelectedRecords = newSelectedRecords.map((rec) => {
        rec.selected = true;
        return rec;
      });
    }
    if (records && !bool) {
      newSelectedRecords = newSelectedRecords.map((rec) => {
        rec.selected = false;
        return rec;
      });
    }
    this.setState({
      selectedRecords: newSelectedRecords,
    });
    this.props.dispatch(setSelectedItems(newSelectedRecords));
  };
  updateRecord = (id, updatedRecord, selectAll) => {
    const recordIndex = this.state.records.findIndex((record) => record.id === id);
    const records = cloneDeep(this.state.records);

    records[recordIndex] = { ...records[recordIndex], ...updatedRecord };

    if (typeof updatedRecord.selected === 'boolean') {
      if (selectAll) {
        this.selectRecordHandler(records[recordIndex], updatedRecord.selected, records);
      } else {
        this.selectRecordHandler(records[recordIndex], updatedRecord.selected);
      }
    }
    this.setState({
      records: records,
    });
  };
  mainCheckboxDisabledDeterminer = () => {
    let disabled = true;
    const recordsToSelect = this.state.records.filter((record) => {
      return !this.props.selectableRowDisabled(record);
    });
    if (recordsToSelect.length > 0) {
      disabled = false;
    }
    return disabled;
  };

  mainCheckboxCheckedOnLoad = (data = this.state.records) => {
    let selected = false;
    let recordsToSelect = data.filter((record) => {
      return this.props.selectableRowSelected(record);
    });

    const recordsToSelectFiltered = recordsToSelect.filter((record) => {
      return record.selected;
    });

    if (recordsToSelectFiltered.length > 0) {
      selected = true;
    }
    return selected;
  };
  mainCheckboxClickHandler = async (state) => {
    const allRecords = cloneDeep(this.state.records);
    if (state === CHECKBOX_STATES.Checked || state === true) {
      allRecords.forEach((record) => {
        if (record.selected) {
          this.updateRecord(record.id, { selected: false }, allRecords);
        }
      });
      this.setState({
        mainCheckboxSelected: false,
        selectedRecords: [],
      });
      this.props.dispatch(setSelectedItems([]));
    }
    if (state === CHECKBOX_STATES.Indeterminate || state === CHECKBOX_STATES.Empty || state === false) {
      this.setState(
        {
          mainCheckboxSelected: true,
        },
        () => {
          allRecords.forEach((record) => {
            this.updateRecord(record.id, { selected: true }, true);
          });
        }
      );
    }
  };

  render() {
    const filters = this.props.filters.map((filter) => {
      return (
        <FilterFactory
          key={filter.field}
          config={filter}
          onChange={this.handleFilterValueChange}
          value={this.state.filtersValue[filter.field]}
        />
      );
    });

    return (
      <>
        <TabFilters
          showTabFilters={this.props.tabFilters?.showTabFilters}
          setTabFiltersOptions={this.props.tabFilters?.setTabFiltersOptions}
          options={this.props.tabFilters?.options}
          handleFiltersChange={this.handleFilter}
          handleFilterValueChange={this.handleFilterValueChange}
        />
        <SubHeader
          filtersCollection={filters}
          visibleFilters={this.props.filters.filter((f) => f.type !== 'HIDDEN')}
          onClick={this.handleFilter}
          filtering={this.state.filtering}
          reloadGrid={this.props.reloadGrid}
        />
        <div className='mobile-datatable'>
          <div className='mobile-datatable-summary'>
            <img src={downloadIcon} onClick={this.handleExport} alt='' />
            {this.props.recordCounter && (
              <div className='number-of-records'>
                <span>
                  <FormattedMessage id='Searched results' />: {this.state.data.count}
                </span>
              </div>
            )}
            {this.props.isSummary && <img style={{ height: '30px' }} src={summaryIcon} onClick={this.handleSummary} alt='' />}
          </div>
          <div className='mobile-datatable-content'>
            <div className='mobile-header'>
              {this.props.selectable && (
                <CheckboxWrapper
                  selected={this.state.mainCheckboxSelected}
                  disabled={this.mainCheckboxDisabledDeterminer()}
                  handleClick={this.handleFilter}
                />
              )}
              <div className={'mobile-header-labels'}>
                <span>
                  <FormattedMessage id='Data' />
                </span>
                <span>
                  <FormattedMessage id='Actions / titles' />
                </span>
              </div>
            </div>
            <div className={`mobile-list ${this.state.filtering ? 'filtering' : ''}`} key={this.state.filtering}>
              <InfiniteScroll
                pageStart={1}
                initialLoad={false}
                loadMore={this.loadMore}
                hasMore={this.state.records.length < this.state.data?.count}
                loader={<Loader />}
              >
                {this.state.records.map((record) => (
                  <Record
                    key={record.id}
                    selectable={this.props.selectable}
                    selected={record.selected}
                    selectedRecords={this.state.selectedRecords}
                    selectableRowDisabled={this.props.selectableRowDisabled}
                    selectableRowSelected={this.props.selectableRowSelected}
                    updateRecordHandler={this.updateRecord}
                    record={record}
                    recordLines={this.props.recordLines}
                    recordHeaderKey={this.props.recordHeaderKey}
                    actions={this.props.actions}
                    showActions={this.props.showActions}
                  />
                ))}
              </InfiniteScroll>
            </div>
          </div>
        </div>
        <ActionBar
          active={this.props.selectable}
          selectedRows={this.state.selectedRecords}
          forceReloadFn={this.props.forceReloadFn}
          actionBarComponents={this.props.actionBarComponents}
          mobileTexts
        />
        <SummaryModal
          isOpen={this.state.isSummaryOpen}
          isSummaryLoading={this.state.isSummaryLoading}
          data={this.state.summaryData}
          onRequestClose={() => this.setState({ isSummaryOpen: false })}
        />
      </>
    );
  }
}

MobileDataTable.propTypes = {
  url: PropTypes.string.isRequired,
  filters: PropTypes.array.isRequired,
  recordLines: PropTypes.array.isRequired,
  recordHeaderKey: PropTypes.string.isRequired,
  isSummary: PropTypes.bool.isRequired,
  actions: PropTypes.func,
  actionBarComponents: PropTypes.array,
  showActions: PropTypes.bool,
  defaultFilters: PropTypes.object,
  recordCounter: PropTypes.bool,
  sortDirection: PropTypes.string,
  reloadGrid: PropTypes.string,
};

MobileDataTable.defaultProps = {
  actions: () => {},
  showActions: false,
  defaultFilters: {},
  recordCounter: true,
  sortDirection: 'DESC',
  actionBarComponents: [],
  reloadGrid: null,
};

export default MobileDataTable;
